import multistore from '~/../config/multistore.json'
import { DEFAULT_CURRENCY } from '~/lib/constants'

export default function getCurrency(locale) {
  return multistore?.[locale]?.currency ?? DEFAULT_CURRENCY
}
